var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"slide",staticClass:"slide",class:_vm.pos,style:({backgroundImage: 'url(' + _vm.source + ')'}),on:{"click":_vm.clicked,"mouseover":_vm.over,"mouseout":_vm.out}},[_c('p',{ref:"title",staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65d5831c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slide.vue
// module id = 49
// module chunks = 0